"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFirstCourseThird = exports.updateFirstCourseSecond = exports.teacherSubmitThird = exports.teacherSubmitSecond = exports.teacherAllList = exports.schoolReviewThird = exports.schoolReviewSecond = exports.saveAuditNumber = exports.jiangsuMatchList = exports.insertSelfEvaluation = exports.insertOutline2 = exports.insertOutline = exports.insertFirstCourseThird = exports.insertFirstCourseSecond = exports.insertFile1 = exports.insertFile = exports.insertCurriculumConstructionPlan = exports.insertCourseTeam2 = exports.insertCourseTeam = exports.insertCourseOverview = exports.insertCourseLeader = exports.insertCourseIntroduction = exports.insertCourseAssessment = exports.insertCourseApplication = exports.insertCourse = exports.insertConstructionMeasures = exports.getThirdList = exports.getSecondList = exports.getPreviewInfoByIdThird = exports.getPreviewInfoByIdSecond = exports.getPdf = exports.getMatchMajorListAll = exports.getMatchById = exports.getListAuditNumber = exports.getInfoByIdThird = exports.getInfoByIdSecond = exports.getFirstCourseThird = exports.getFirstCourseSecond = exports.getAllList = exports.deleteByIdThird = exports.deleteByIdSecond = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 申报列表/jiangsuTableSecond/deleteById
 */

//学校删除课程
var deleteByIdSecond = exports.deleteByIdSecond = function deleteByIdSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/deleteById',
    method: 'post',
    data: data
  });
};
var deleteByIdThird = exports.deleteByIdThird = function deleteByIdThird(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/deleteById',
    method: 'post',
    data: data
  });
};
// 附件三 学校修改课程 提交
var updateFirstCourseThird = exports.updateFirstCourseThird = function updateFirstCourseThird(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/updateFirstCourse',
    method: 'post',
    data: data
  });
};
// 附件二 学校修改课程 提交
var updateFirstCourseSecond = exports.updateFirstCourseSecond = function updateFirstCourseSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/updateFirstCourse',
    method: 'post',
    data: data
  });
};
// 附件三 学校修改课程 数据回显
var getFirstCourseThird = exports.getFirstCourseThird = function getFirstCourseThird(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/getFirstCourse',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
// 附件二 学校修改课程 数据回显
var getFirstCourseSecond = exports.getFirstCourseSecond = function getFirstCourseSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/getFirstCourse',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
// 设置根据项目id获取详情
var getMatchById = exports.getMatchById = function getMatchById(data) {
  return _api.default.request({
    url: '/match/getMatchById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
// 设置最大审核数/match/getMatchById
var getListAuditNumber = exports.getListAuditNumber = function getListAuditNumber(data) {
  return _api.default.request({
    url: '/jiangsuTableAuditNumber/getList',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
// 设置最大审核数
var saveAuditNumber = exports.saveAuditNumber = function saveAuditNumber(data) {
  return _api.default.request({
    url: '/jiangsuTableAuditNumber/saveAuditNumber',
    method: 'post',
    data: data
  });
};
// 获取专业大类
var getMatchMajorListAll = exports.getMatchMajorListAll = function getMatchMajorListAll(data) {
  return _api.default.request({
    url: '/matchMajor/getMatchMajorListAll',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
// 项目列表
var jiangsuMatchList = exports.jiangsuMatchList = function jiangsuMatchList(data) {
  return _api.default.request({
    url: '/match/jiangsuMatchList',
    method: 'post',
    data: data
  });
};
// 江苏附件二（验收认定申报 学校 向上级推荐 或退回 申报书
var schoolReviewSecond = exports.schoolReviewSecond = function schoolReviewSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/review',
    method: 'post',
    data: data
  });
};
// 江苏附件三（立项建设申报） 学校 向上级推荐 或退回 申报书
var schoolReviewThird = exports.schoolReviewThird = function schoolReviewThird(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/review',
    method: 'post',
    data: data
  });
};
// 江苏附件二（验收认定申报） 老师向学校提交申报书
var teacherSubmitSecond = exports.teacherSubmitSecond = function teacherSubmitSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/submit',
    method: 'post',
    data: data
  });
};
// 江苏附件三（立项建设申报） 老师向学校提交申报书
var teacherSubmitThird = exports.teacherSubmitThird = function teacherSubmitThird(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/submit',
    method: 'post',
    data: data
  });
};
// 江苏附件二（验收认定申报） 学校 添加申报课程
var insertFirstCourseSecond = exports.insertFirstCourseSecond = function insertFirstCourseSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertFirstCourse',
    method: 'post',
    data: data
  });
};
// 江苏附件三（立项建设申报） 学校 添加申报课程
var insertFirstCourseThird = exports.insertFirstCourseThird = function insertFirstCourseThird(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/insertFirstCourse',
    method: 'post',
    data: data
  });
};
// 学校获取老师用户列表
var teacherAllList = exports.teacherAllList = function teacherAllList(data) {
  return _api.default.request({
    url: '/user/teacherAllList',
    method: 'post',
    data: data
  });
};
// 江苏附件二（全部申报）
var getAllList = exports.getAllList = function getAllList(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/getAllList',
    method: 'post',
    data: data
  });
};
// 江苏附件二（验收认定申报） 分页查询
var getSecondList = exports.getSecondList = function getSecondList(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/list',
    method: 'post',
    data: data
  });
};
// 江苏附件三（立项建设申报） 分页查询
var getThirdList = exports.getThirdList = function getThirdList(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/list',
    method: 'post',
    data: data
  });
};
// 江苏附件二（验收认定申报） 表单预览
var getPreviewInfoByIdSecond = exports.getPreviewInfoByIdSecond = function getPreviewInfoByIdSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/getPreviewInfoById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
// 江苏附件三（立项建设申报） 表单预览
var getPreviewInfoByIdThird = exports.getPreviewInfoByIdThird = function getPreviewInfoByIdThird(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/getPreviewInfoById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
// 江苏附件二（验收认定申报） 根据id获取
var getInfoByIdSecond = exports.getInfoByIdSecond = function getInfoByIdSecond(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/getInfoById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
// 江苏附件三（立项建设申报） 根据id获取
var getInfoByIdThird = exports.getInfoByIdThird = function getInfoByIdThird(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/getInfoById',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 江苏附件三 精品在线开放课程立项建设申报/
 */

// 概要信息 提交
var insertOutline = exports.insertOutline = function insertOutline(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/insertOutline',
    method: 'post',
    data: data
  });
};
// 课程负责人情况 提交
var insertCourseLeader = exports.insertCourseLeader = function insertCourseLeader(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/insertCourseLeader',
    method: 'post',
    data: data
  });
};
// 课程团队 提交
var insertCourseTeam = exports.insertCourseTeam = function insertCourseTeam(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/insertCourseTeam',
    method: 'post',
    data: data
  });
};
// 课程情况 提交
var insertCourseOverview = exports.insertCourseOverview = function insertCourseOverview(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/insertCourseOverview',
    method: 'post',
    data: data
  });
};
// 课程评价 提交
var insertSelfEvaluation = exports.insertSelfEvaluation = function insertSelfEvaluation(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/insertSelfEvaluation',
    method: 'post',
    data: data
  });
};
// 建设措施 提交
var insertConstructionMeasures = exports.insertConstructionMeasures = function insertConstructionMeasures(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/insertConstructionMeasures',
    method: 'post',
    data: data
  });
};
// 附件材料 提交
var insertFile1 = exports.insertFile1 = function insertFile1(data) {
  return _api.default.request({
    url: '/jiangsuTableThird/insertFile',
    method: 'post',
    data: data
  });
};
/*
 * 验收认定申报
 */

// 概要信息 提交
var insertOutline2 = exports.insertOutline2 = function insertOutline2(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertOutline',
    method: 'post',
    data: data
  });
};
// 课程基本情况 提交
var insertCourse = exports.insertCourse = function insertCourse(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertCourse',
    method: 'post',
    data: data
  });
};
// 课程团队 提交
var insertCourseTeam2 = exports.insertCourseTeam2 = function insertCourseTeam2(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertCourseTeam',
    method: 'post',
    data: data
  });
};
// 课程简介和特色 提交
var insertCourseIntroduction = exports.insertCourseIntroduction = function insertCourseIntroduction(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertCourseIntroduction',
    method: 'post',
    data: data
  });
};
// 课程考核（试）情况 提交
var insertCourseAssessment = exports.insertCourseAssessment = function insertCourseAssessment(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertCourseAssessment',
    method: 'post',
    data: data
  });
};
// 课程应用情况 提交
var insertCourseApplication = exports.insertCourseApplication = function insertCourseApplication(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertCourseApplication',
    method: 'post',
    data: data
  });
};
// 课程建设计划 提交
var insertCurriculumConstructionPlan = exports.insertCurriculumConstructionPlan = function insertCurriculumConstructionPlan(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertCurriculumConstructionPlan',
    method: 'post',
    data: data
  });
};
// 附件材料 提交
var insertFile = exports.insertFile = function insertFile(data) {
  return _api.default.request({
    url: '/jiangsuTableSecond/insertFile',
    method: 'post',
    data: data
  });
};
// 下载pdf responseType: "blob"
var getPdf = exports.getPdf = function getPdf(data) {
  return _api.default.request({
    url: '/jiangsuFile/getPdf',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};